import {  SlotGameType1_3 } from "../SlotGameType1_3";
export class LuckyIce20_3 extends SlotGameType1_3{ }